import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, getHondaCustomerJourney, getHondaNpsBar, getNode, GREEN_1, HONDA_COLORS_CONFIG, HONDA_SCALE_3_COLORS, isAllFilterByLevel, msurPorcRespuestasMapper, msurTooltipTotalRegistros, RED_1 } from '../commonWidgetsHonda'
import { getLineDetailedRadar } from '../../widgetsLibrary/widgetsLine'
import { answeredMapper, invalidMapper, isGeoLocationLeaf } from '../../dashHelper'
import useAccount from '@hooks/useAccount'


export default {
    title: 'Honda - Venta',
    description: 'Dashboard Honda Motos - Postventa',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        const { geoLocations } = useAccount();
        
        //Para filtra por nivel Distribuidor, todos los filtros deben ser del mismo nivel
        let isGroupLevelDistribuidor = isAllFilterByLevel(geoLocations, filters, 'DISTRIBUIDOR');
                
        
      const widgetsArray = [ 
 getLineDetailedRadar({
      mainIndicator: 'hon_moto_pv_npm_servicio_valor',
      radialIndicators: [
        //'NPS_ASESOR_MOTOS',
        'NPS_INSTALACIONES_MOTOS',
        'NPS_INICIACION_MOTOS',
        'NPS_ENTREGA_MOTOS',
        'NPS_CALIDAD_MOTOS'
      ],
      radialType: 'byIndicator',
      position: [0, 0],
      size: [4, 3],
      title: 'Satisfacción General',
      groupByLevel: 3,
      extras: {
        formula: 'nps-10',
      },
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
        showRadialChart: true,
        initialVisibleChart: 1,
        /* maxValue: 10, */
        formulaRadial: 'wavg',
        showSample: false,
      },
      useNormalizedRadial: true,
      normalizeBottom: 0,
      normalizeTop: 10,
      criticalMomentInclude: [1],
      indicatorsNames: {
        //'NPS_ASESOR_MOTOS': 'Asesor',
        'NPS_INSTALACIONES_MOTOS': 'Instalaciones',
        'NPS_INICIACION_MOTOS': 'Iniciación',
        'NPS_ENTREGA_MOTOS': 'Entrega',
        'NPS_CALIDAD_MOTOS': 'Calidad',
      },
    }),
    //1
    {
      title: 'Encuestas',
      type: 'label',
      position: [0, 3],
      size: [4, 1],
      config: { color: '#B7AADC' },
    },
    
            



              getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS General',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'hon_moto_pv_nps',
                //criticalMomentInclude: [13551],//this critical momenet id overwrits the others
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: HONDA_SCALE_3_COLORS,
                    useCurrent: 0,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                    valueSymbol: '%',
                }
            }),

            getHondaNpsBar({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: 'NPS Detalle',
                key: 'bar-by-question-nps',
                size: [2, 2],
                indicator: 'hon_moto_pv_nps',
                extraConfigs: {
                    colors: HONDA_SCALE_3_COLORS,
                    //groupLabels: mapLables,
                    showLegend: false,
                    valueFormat: ' >-.0',
                },
            }),            

            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'surveyCountTrendByMonth',
              position: [0, 4],
              size: [1, 2],
              indicator: 'survey-response-counters',
              extras:{
                sort: { sortBy: 'group', value: 'asc' }
              }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Index',
                size: [1, 2]    ,
                indicator: 'hon_moto_pv_servicio_satisfactorio',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'gaugeGenericByStatus',
                  title: 'widgets.calidadDatosVenta',
                  position: [2, 6],
                  size: [1, 2],
                  mapper: invalidMapper,
                  url: 'survey-responses/values',
                  extraConfigs: {
                    showPercentage: true,
                  },
                }),
                getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'gaugeGenericByStatus',
                  title: 'widgets.porcRespuestasVenta',
                  position: [3, 6],
                  size: [1, 2],
                  mapper: answeredMapper,
                  url: 'survey-responses/values',
                  extraConfigs: {
                    showPercentage: true,
                  }
                }),
            

            getHondaCustomerJourney({
                  id: 'cj-motos-vp',
                  //position: [0, 12],
                  size: [4, 2],
                  indicators: [
                    { name: 'hon_moto_pv_npm_agendo_cita', formula: 'wavg' }, 
                    { name: 'hon_moto_pv_npm_eficiencia_recepcion', formula: 'wavg' }, 
                    { name: 'hon_moto_pv_npm_limpieza_unidad', formula: 'wavg' },
                    { name: 'hon_moto_pv_npm_servicio_valor', formula: 'wavg' },
                  ],
                  title: 'Proceso de postventa motos',
                }),

            !isGroupLevelDistribuidor ?
                getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'rankingByGeoBest',
                  title: 'widgets.bestGeoLocationsVentaGrupo',
                  position: [2, 10],
                  size: [2, 2],
                  extraConfigs: {
                    backgroundColor: '#501C78',
                    titleBackgroundColor: '#88DD76',
                    symbol: '',
                    showFirstIndex: true,
                    id: 'rankingByGeoBestGrupoMoto',
                  },
                  indicator: 'hon_moto_pv_servicio_satisfactorio',
                  extras: {
                    groupByLevel: 3,                    
                  },
            })
            :undefined,

            !isGroupLevelDistribuidor ?
                getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'rankingByGeoWorst',
                  title: 'widgets.worstGeoLocationsVentaGrupo',
                
                  position: [3, 10],
                  size: [2, 2],
                  extraConfigs: {
                    backgroundColor: '#501C78',
                    titleBackgroundColor: '#db7476',
                    symbol: '',
                    showFirstIndex: true,
                    id: 'rankingByGeoWorstGrupo',
                  },
                  indicator: 'hon_moto_pv_servicio_satisfactorio',
                  extras: {
                    groupByLevel: 3,        
                  },
            })
            :undefined,

            !isGroupLevelDistribuidor ?
                getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'rankingByGeoBest',
                  title: 'widgets.bestGeoLocationsVentaDist',
                  position: [2, 10],
                  size: [2, 4],
                  extraConfigs: {
                    backgroundColor: '#501C78',
                    titleBackgroundColor: '#88DD76',
                    symbol: '',
                    showFirstIndex: true,
                    limit: 11,
                    maxSlice: 11,
                  },
                  indicator: 'hon_moto_pv_servicio_satisfactorio',
                  extraIndicatorConfigs: {
                    //limit: 11,
                  }
            })
            :undefined,

            !isGroupLevelDistribuidor ?
                getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'rankingByGeoWorst',
                  title: 'widgets.worstGeoLocationsVentaDist',
                  position: [3, 10],
                  size: [2, 4],
                  extraConfigs: {
                    backgroundColor: '#501C78',
                    titleBackgroundColor: '#db7476',
                    symbol: '',
                    showFirstIndex: true,
                    limit: 11,
                    maxSlice: 11,
                  },
                  indicator: 'hon_moto_pv_servicio_satisfactorio',
                  extraIndicatorConfigs: {
                    //limit: 11,
                  }
            })
            :undefined,



  {
    title: 'Nube de Palabras / Frecuencia en comentarios',
    position: [0, 13],
    size: [2, 2,],
    config: {
      id: 'word-count',
      type: 'wordCloud',
      mapper: (data: any, extra: any) => {
        return data !== undefined
          && data.map !== undefined
          ? data.map((item: any) => ({
              ...item,
              group: item.group ?? item.category
            }))
          : []
      },
      indicators: [
        {
          indicator: 'WORD_COUNT',
          keyExtract: ['count', 'value', 'group','category'],
          singleton: true,
        },
      ],
    },
  },
  
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagBest',
      title: 'widgets.bestTagsVenta',
      position: [2, 13],
      size: [2, 2],
      indicator: 'sentiment',
      //criticalMomentId: 1,
      extras: {
        trunc: 'HALF_DOWN',
        topSize: 3,
      },
      extraConfigs: {
        layout: 'signal',
        tone: 'positive',
        headerBadge: 'Top',
        countLabel: 'menciones',
        color: GREEN_1,
      },
      extraIndicatorConfigs: {
        limit: 2,
        value: 'count',
      },      
    }),    
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagWorst',
      title: 'widgets.worstTagsVenta',
      position: [2, 15],
      size: [2, 2],
      indicator: 'sentiment',
      //criticalMomentId: 1,
      extras: {
        resultType: 'bottom',
        trunc: 'HALF_UP',
        bottomSize: 3,
      },
      extraConfigs: {
        layout: 'signal',
        tone: 'negative',
        headerBadge: 'Atención',
        countLabel: 'menciones',
        color: RED_1,
      },
      extraIndicatorConfigs: {
        limit: 2,
        value: 'count',
      },      
    }),
   
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'widgets.sentimentAnalysis',
      position: [0, 15],
      size: [4, 3],
      //criticalMomentId: 1,
      extraConfigs:   {
          colors: HONDA_SCALE_3_COLORS, 
          typeColumn: 'percent', 
          //widgetTitle: 'Análisis de sentimientos top 6' ,
          groupKeys: ['positive', 'neutral', 'negative'],
          groupLabels: {'positive': 'Promotores', 'neutral': 'Neutros', 'negative': 'Detractores'},
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'diagramaIshikawa',
      title: 'Diagrama Ishikawa',
      position: [0, 18],
      size: [4, 3],
      indicator: 'sentiment',
      //criticalMomentId: 1,
    }),
     {
      title: 'widgets.otherIndicators',
      type: 'label',
      position: [0, 21],
      size: [4, 1],
    },


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Le recordaron el mantenimiento',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_moto_pv_recordatorio_mantenimiento'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Agendó cita para mantenimiento',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_moto_pv_agendo_cita'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Atención que recibió por parte del personal al llegar al taller de servicio',
                size: [1, 2],
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                    colors: HONDA_COLORS_CONFIG,
                },
                indicator: 'hon_moto_pv_npm_agendo_cita'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Eficiencia durante la recepción',
                size: [1, 2],
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                    colors: HONDA_COLORS_CONFIG,
                },
                indicator: 'hon_moto_pv_npm_eficiencia_recepcion'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Le informaron el avance de los trabajos realizados a su moto',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_moto_pv_info_avance'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Limpieza de la unidad después del servicio',
                size: [1, 2],
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                    colors: HONDA_COLORS_CONFIG,
                },
                indicator: 'hon_moto_pv_npm_limpieza_unidad'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Primera reparación',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_moto_pv_primera_reparacion'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Le explicaron el trabajo realizado a su moto',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_moto_pv_trabajo_explicado'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Le informaron sobre el próximo servicio',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_moto_pv_info_prox_servicio'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Cumplieron con la fecha de entrega',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_moto_pv_cumpliero_fecha_entrega'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Eficiencia durante la entrega',
                size: [1, 2],
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                    colors: HONDA_COLORS_CONFIG,
                },
                indicator: 'hon_moto_pv_npm_eficiencia_entrega'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Relación costo - beneficio del servicio',
                size: [1, 2],
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                    colors: HONDA_COLORS_CONFIG,
                },
                indicator: 'hon_moto_pv_npm_servicio_valor'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Esatado de las instalaciones del taller de servicio',
                size: [1, 2],
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                    colors: HONDA_COLORS_CONFIG,
                },
                indicator: 'hon_moto_pv_npm_estado_instalaciones'
            }),

            {
              title: 'widgets.otherIndicators',
              type: 'label',
              position: [0, 21],
              size: [4, 1],
            },


            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'barByGeo',
              title: 'widgets.grupoSatisfactionMotos',
              key: 'venta-satisfaccion-grupo-motos',
              position: [0, 30],
              size: [4, 2],
              indicator: 'hon_moto_pv_nps',
              //criticalMomentId: 1,
              extraConfigs: {
                colors: HONDA_COLORS_CONFIG,
                itemsWidth: 200,
                percentageScale: true,
                decimals: 1,
                maxValue: 100,
                showLegend:false,
                rotateXAxisLegend: true,
                wrapTexts: true,
                labelFontSize: 10,
              },
              extras: {
                geoLocationInclude: [3],
                groupByLevel: 3
              },
              render: (filters) => {
                return !isGeoLocationLeaf(filters, filtersData)
              },
              mapper: (data: any) => {
                //console.info('data mapper')
                //console.info(data)
                return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
                  ...item,
                  label: item.label !== undefined
                    ? item.label.replaceAll('MITSUBISHI ', '')
                    : item.label
                }))
              },
            }),

            getCommonWidget({
                  commonWidgets: commonWidgets,
                  name: 'barByGeo',
                  title: 'widgets.distribuidorSatisfactionMotos',
                  key: 'venta-satisfaccion-dist-motos-distribuidor',
                  position: [0, 30],
                  size: [4, 2],
                  indicator: 'hon_moto_pv_nps',
                  //criticalMomentId: 1,
                  extraConfigs: {
                    colors: HONDA_COLORS_CONFIG,
                    itemsWidth: 200,
                    percentageScale: true,
                    decimals: 1,
                    maxValue: 100,
                    rotateXAxisLegend: true,
                    wrapTexts: true,
                    labelFontSize: 10,
                    showLegend:false,        
                  },
                  extras: {
                    geoLocationInclude: [3],
                    groupByLevel: 6
                  },
                  render: (filters) => {
                    return !isGeoLocationLeaf(filters, filtersData)
                  },
                  mapper: (data: any) => {
                    return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
                      ...item,
                      label: item.label !== undefined
                        ? item.label.replaceAll('MITSUBISHI ', '')
                        : item.label
                    }))
                  },
                })




    ].filter(w => w != undefined);
    return widgetsArray;
  },
} as DasboardConfig
